import {useMutation} from "@tanstack/react-query";

import {loginService} from "../services/account/login.service";
import {useAuthStore} from "../store/useAuth.store";
import useGetAppConfig from "./useGetAppConfig";

const useLogin = () => {
  const login = useAuthStore(state => state.login);
  const {refetch} = useGetAppConfig();

  const {
    data,
    isError,
    isPending,
    error,
    mutate: postLogin,
    isSuccess,
  } = useMutation({
    mutationKey: ["login"],
    mutationFn: loginService,
    onSuccess: ({data}) => {
      // set data in store
      login(data);
      //refetch App Config to load data
      refetch();
    },
    onError: _error => {},
  });

  return {
    postLogin,
    data,
    isError,
    isPending,
    isSuccess,
    error,
  };
};

export default useLogin;
